import { useState, useEffect } from 'react';

export function useElementSize(nodeRef = null) {
  const [ref, setRef] = useState(nodeRef?.current);
  const [size, setSize] = useState({});

  useEffect(() => {
    if (!ref) return;

    const observer = new ResizeObserver(([entry]) =>
      setSize(entry.contentRect)
    );

    observer.observe(ref);
    return () => observer.disconnect();
  }, [ref]);

  return [setRef, size];
}
